module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-6-7cf19d369818157c8e498db36e4b21e3.jpg";